import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import "./style.css";
import { BlockOrg } from "../../../../RoleChecker";
import BootstrapTable from "react-bootstrap-table-next";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { ProjectDocumentForm } from "./ProjectDocumentForm";
import { ActionButton } from "../../../../../_metronic/_partials/controls/ActionButton";

export default function ProjectDocument({
  createDocument,
  documents = [],
  deleteDocument
}) {
  const blockOrg = BlockOrg();
  const { actionsLoading } = useSelector(({ project }) => ({
    actionsLoading: project.actionsLoading
  }));

  const [showDocModal, setShowDocModal] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState(null);

  function submitDeleteDocument() {
    if (documentToDelete) {
      const callback = () => {
        setDocumentToDelete(null);
      };

      deleteDocument(documentToDelete, callback);
    }
  }

  const columns = [
    {
      text: "Caption",
      dataField: "project_file.caption"
    },
    {
      text: "Dokumen",
      dataField: "uuid",
      formatter: (cell, row) => {
        return (
          <div className="d-flex justify-content-end">
            <a
              className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
              href={`${row.storage}/${row.path}`}
              target="_blank"
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/General/Visible.svg")}
                />
              </span>
            </a>
            <button
              className="btn btn-icon btn-light btn-hover-danger btn-sm"
              onClick={() => setDocumentToDelete(row)}
            >
              <span className="svg-icon svg-icon-md svg-icon-danger">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                />
              </span>
            </button>
          </div>
        );
      }
    }
  ];

  return (
    <>
      {blockOrg && (
        <ProjectDocumentForm
          show={showDocModal}
          onHide={() => setShowDocModal(false)}
          loading={actionsLoading}
          submit={createDocument}
        />
      )}
      <Modal
        show={Boolean(documentToDelete)}
        onHide={() => setDocumentToDelete(null)}
      >
        <Modal.Header>
          <Modal.Title>Hapus Dokumen</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <div className="d-flex align-items-center">
            <ActionButton
              variant="secondary"
              className={"mr-3"}
              text="Batal"
              onClick={() => setDocumentToDelete(null)}
            />
            <ActionButton
              variant="danger"
              text="Hapus"
              loading={actionsLoading}
              onClick={submitDeleteDocument}
            />
          </div>
        </Modal.Footer>
      </Modal>
      <Card>
        <CardHeader title="Dokumen">
          <CardHeaderToolbar>
            {blockOrg && (
              <button
                className="btn btn-primary mr-2"
                onClick={() => setShowDocModal(true)}
              >
                Tambah Dokumen
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            bordered
            columns={columns}
            data={documents}
            keyField="uuid"
            remote
          />
        </CardBody>
        <CardFooter></CardFooter>
      </Card>
    </>
  );
}
